export default __webpack_public_path__ + "static/media/textbook-img.e8ace343.png";